import { Component, DestroyRef, EventEmitter, Input, OnInit, Output, inject, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from '@coin/shared/auth/data-access';

@Component({
  selector: 'coin-siemens-energy-login-screen',
  templateUrl: './login-screen.component.html',
  styleUrls: ['./login-screen.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class LoginScreenComponent implements OnInit {
  private auth = inject(AuthService);
  private destroyRef = inject(DestroyRef);

  @Input() public autoLogin = false;
  @Input() public redirectUrl: string | null = null;
  @Output() public idTokenChanged: EventEmitter<string> = new EventEmitter<string>();

  ngOnInit(): void {
    this.auth.idToken$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((token: string) => this.idTokenChanged.emit(token));

    if (this.autoLogin) {
      this.login();
    }
  }

  public login(): void {
    this.auth.login(this.redirectUrl);
  }
}
